import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import apiClient from "../api/client";
import "../styles/auth.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [form, setForm] = useState({ password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [done, setDone] = useState(false);

  const update = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));

  if (!token) {
    return (
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", background: "#f2efe8" }}>
        <Navbar />
        <div className="auth-page">
          <div className="auth-card">
            <h1 className="auth-heading">Invalid link</h1>
            <p className="auth-sub">
              This password reset link is invalid or has expired.
            </p>
            <div className="auth-switch" style={{ marginTop: "1.5rem" }}>
              <Link to="/forgot-password">Request a new link →</Link>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.password) {
      setError("Please enter a new password.");
      return;
    }
    if (form.password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (form.password !== form.confirm) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      await apiClient.post("/api/auth/reset-password", {
        token,
        newPassword: form.password,
      });
      setDone(true);
      // replace: the URL being left carries a now-spent reset token, and
      // back must not return to it.
      setTimeout(() => navigate("/login", { replace: true }), 3000);
    } catch (err) {
      setError(
        err.message?.includes("expired")
          ? "This reset link has expired. Please request a new one."
          : "Something went wrong. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", background: "#f2efe8" }}>
        <Navbar />
        <div className="auth-page">
          <div className="auth-card">
            <div className="auth-success-state">
              <div className="auth-success-icon">✓</div>
              <h1 className="auth-heading">Password updated</h1>
              <p className="auth-sub">
                Your password has been reset successfully. Redirecting you to sign
                in...
              </p>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", background: "#f2efe8" }}>
      <Navbar />
      <div className="auth-page">
        <div className="auth-card">
          <Link to="/" className="logo">
            <span>
              ScriptedCAD
            </span>
          </Link>

          <h1 className="auth-heading">Set new password</h1>
          <p className="auth-sub">Choose a strong password for your account.</p>

          {error && (
            <div className="auth-error">
              {error}
              {error.includes("expired") && (
                <Link to="/forgot-password" className="auth-error-link">
                  {" "}
                  Get new link →
                </Link>
              )}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="auth-field">
              <label>New password</label>
              <div className="auth-input-wrap">
                <input
                  type={showPassword ? "text" : "password"}
                  value={form.password}
                  onChange={update("password")}
                  placeholder="At least 6 characters"
                  autoFocus
                />
                <button
                  type="button"
                  className="auth-show-pw"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
            </div>
            <div className="auth-field">
              <label>Confirm new password</label>
              <div className="auth-input-wrap">
                <input
                  type={showConfirm ? "text" : "password"}
                  value={form.confirm}
                  onChange={update("confirm")}
                  placeholder="Same password again"
                />
                <button
                  type="button"
                  className="auth-show-pw"
                  onClick={() => setShowConfirm(!showConfirm)}
                >
                  {showConfirm ? "Hide" : "Show"}
                </button>
              </div>
            </div>
            <button type="submit" className="auth-btn" disabled={loading}>
              {loading && <span className="auth-spinner" />}
              {loading ? "Updating..." : "Update password"}
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ResetPasswordPage;
